import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { Alert } from 'src/app/shared/class/Alert';
export class UpdateDatabaseListComponent {
    constructor(updateDatabaseService, spinner) {
        this.updateDatabaseService = updateDatabaseService;
        this.spinner = spinner;
        this.goback = '';
        this.subscription = new Subscription();
        this.displayedColumns = ['id', 'name', 'updated', 'update'];
        this.tables = [];
    }
    ngOnInit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.reloadTable();
        });
    }
    reloadTable() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                this.spinner.show();
                const data = yield this.updateDatabaseService.getTables();
                this.tables = (data.status === undefined) ? data : [];
                this.dataSource = new MatTableDataSource(this.tables);
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
                this.spinner.hide();
            }
            catch (error) {
                this.spinner.hide();
                console.error(error);
            }
        });
    }
    applyFilter(event) {
        const filterValue = event.target.value;
        this.dataSource.filter = filterValue.trim().toLowerCase();
        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }
    updateTable(endpoint) {
        this.spinner.show();
        this.subscription.add(this.updateDatabaseService.updateTable(endpoint).subscribe(() => {
            this.spinner.hide();
            Alert.success(Alert.getMessage().success.updateTable).then(() => this.reloadTable());
        }, () => {
            this.spinner.hide();
            Alert.error(Alert.getMessage().errors.updateTable);
        }));
    }
}
